export default __webpack_public_path__ + "static/media/Lila Myla 9781408330678.e1b82727.jpg";